import { ca } from '@cian/analytics';

export const trackInfoExpand = () => {
  ca('eventSite', {
    action: 'Click',
    category: 'RosReestr',
    label: 'ShowDetail',
    name: 'oldevent',
    useLastProducts: true,
  });
};

export const trackCadastralMapView = () => {
  ca('eventSite', {
    action: 'Show_sopr',
    category: 'CadastralMap',
    name: 'oldevent',
    useLastProducts: true,
  });
};

export const trackCadastralMapPreviewClick = () => {
  ca('eventSite', {
    action: 'Click_sopr',
    category: 'CadastralMap',
    name: 'oldevent',
    useLastProducts: true,
  });
};
